import { Modal } from 'react-bootstrap';
import React from 'react';

const Advertisement = ({ adInfo, setShow, show }) => {

    const adBoxStyle = `
        .ad-img{
          width: 60vw;
         height: 60vh;
         cursor: pointer;
         }
         @media (max-width: 575px) {
            .ad-img{
                width: 100vw;
               height: 45vh;
               }
               .ad-modal-bg{
                   margin-top: -30px;
                   border-radius: 0px !important;
               }
          }
         
         `

    return (
        < >
            <style>{adBoxStyle}</style>
            <Modal
                show={show}
                centered
                onHide={() => setShow(!show)}
                className=" modal-bgstyle ad-modal-bg"
                dialogClassName="ad-modal   "
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header className="border-0   m-0 p-0 " closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id="carouselExampleInterval" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            {adInfo?.map((bannerInfo, index) => {
                                return (
                                    <div
                                        key={index + 1}
                                        className={index === 0 ? "carousel-item active" : "carousel-item"}
                                        data-interval="10000">
                                        <a  target="_blank" href={bannerInfo?.link1}>
                                            <img
                                                src={bannerInfo.img1?.url}

                                                className="d-block img-fluid ad-img"
                                                alt="..." />
                                        </a>
                                    </div>
                                )
                            })}

                        </div>
                        {adInfo?.length > 1 &&
                            <>
                                <button className="carousel-control-prev " type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>

                                </button>
                                <button className="carousel-control-next " type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                                    <span className="carousel-control-next-icon bg-dark" aria-hidden="true"></span>

                                </button>
                            </>
                        }
                    </div>

                    
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Advertisement;